import { creativeLibraryApi } from "@/lib/api/creative-library";

/** Read the current gallery and CAS once. A conflict is surfaced for explicit retry. */
export async function attachSubjectReferences(
  subjectToken: string,
  tokens: string[],
) {
  const subject = await creativeLibraryApi.subject(subjectToken);
  const referenceTokens = [...new Set([...subject.referenceTokens, ...tokens])];
  if (subject.unavailableReferenceCount)
    throw new Error("Unavailable gallery references");
  if (referenceTokens.length > 20) throw new Error("Character gallery is full");
  if (referenceTokens.length === subject.referenceTokens.length) return subject;
  return creativeLibraryApi.updateSubject(subjectToken, {
    revision: subject.revision,
    referenceTokens,
  });
}
